class BESSAppThemeSelect extends BESSAppComponent {

    static _cookieName = 'BESSAppThemeSelect';

    constructor() {
        super('.app-theme-select');
    }

    setupComponent(componentNode) {
        return new BESSAppThemeSelectComponent(componentNode);
    }
}

class BESSAppThemeSelectComponent extends BESSAppBase {

    constructor(node) {
        super();
        this.node = node;
        this.node.find('.app-theme-light').bindClickEvent(this, this.#onToggleLight);
        this.node.find('.app-theme-dark').bindClickEvent(this, this.#onToggleDark);
        let theme = Cookies.get(BESSAppThemeSelect._cookieName);
        if(theme !== undefined) {
            if(theme === 'dark' && !($('body').hasClass('dark-theme'))) {
                this.#onToggleDark();
            }
            if(theme === 'light' && $('body').hasClass('dark-theme')) {
                this.#onToggleLight();
            }
        }
    }

    #onToggleLight() {
        $('body').removeClass('dark-theme');
        this.node.find('.app-theme-light').attr('aria-checked', true);
        this.node.find('.app-theme-dark').attr('aria-checked', false);
        Cookies.remove(BESSAppThemeSelect._cookieName);
        BESSApp.instance.services.api.session.apiUpdateTheme('light', () => {
        });
    }

    #onToggleDark() {
        $('body').addClass('dark-theme');
        this.node.find('.app-theme-light').attr('aria-checked', false);
        this.node.find('.app-theme-dark').attr('aria-checked', true);
        Cookies.set(BESSAppThemeSelect._cookieName, 'dark', {expires: 10 * 365})
        BESSApp.instance.services.api.session.apiUpdateTheme('dark', () => {
        });
    }
}